import Api from '@/services/Api'

export default {
  createTask (task) {
    return Api().post('tasks/', task)
  },

  getTasksOfOrder (orderID) {
    return Api().get('tasksOfOrder/' + orderID)
  },

  markTaskAsDone (taskID) {
    return Api().post('taskComplete/' + taskID)
  }
}



// WEBPACK FOOTER //
// ./src/services/TaskService.js